import React, { lazy, Suspense } from 'react';

import {v4 as uuidv4} from 'uuid';

import '@trendmicro/react-breadcrumbs/dist/react-breadcrumbs.css';
import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/css/bootstrap.min.css";

import { Talifoon } from '../events/Talifoon';
import { SidePanelComponent } from '../widgets/SidePanelComponent';
import { Observable } from '../events/Observable';
import { t } from '../services';
import { UPDATE_MENU_EVENT } from "@auto/events/Gui";

const DraggableModalBrowser = lazy(() => import('./DraggableModalBrowser')); // Lazy load to avoid circular dependency

const bootstrapUUID = uuidv4();

export function setContextualOptions(options) {
  const keys = Object.keys(options || {});

  if (!keys.length) {
    return;
  }

  const rootKey = keys[0];
  const baseMenu = menu()[rootKey];
  const nextMenu = baseMenu ? merge(baseMenu, options[rootKey]) : options[rootKey];

  UPDATE_MENU_EVENT.publish({ m: nextMenu });
}

export function setFocus(key) {
  if (key) {
    UPDATE_MENU_EVENT.publish({ k: key });
  }
}

export function cleanContextualOptions(options) {
  const keys = Object.keys(options || {});

  if (!keys.length) {
    return;
  }

  UPDATE_MENU_EVENT.publish({ m: menu()[keys[0]] });
}

export const createBrowserComponent = () => class Browser extends React.Component {
	constructor(props) {
		super(props)
		this.history = null;
		this.size = 0;
        this.limit = 100;
        this.views = new Map();
		this.requestingClose = false;
		this.openSidePanelEvent = new Observable();
		this.clodeSidePanelEvent = new Observable();
		this.openModalEvent = new Observable();
		this.closeModalEvent = new Observable();
		this.bootstrap = {
		  uuid: bootstrapUUID,
		  view: () => <div style={{height: '100%'}} />
		};
		this.register(this.bootstrap);
		this.state = {
		  focusedView: this.bootstrap
		};
		this.canISwitch = new Talifoon();
    }

	register = (v) => {
		this.views.set(v.uuid, v);
	}
	
	unregister = (v) => {
		if (v.getContext)
			cleanContextualOptions(v.getContext());
		this.views.delete(v.uuid);
	}

	canISwitchTo = (v) => {
		if (this.state.focusedView) {
			this.requestingClose = true;
			this.canISwitch.send(this.doSwitchTo(v), () => this.doSwitchTo(v)(true));
		}
	}

	doSwitchTo = (v) => (closeCurrent) => {
		if (closeCurrent) {
			this.switchView(v);
		}
		this.requestingClose = false;
	}

	addToHistory = (data) => {
		// Adding data to the linked list history
		if (!this.history) {
		  this.history = { data, next: null };
		  this.size = 1;
		} else {
		  if (this.size === this.limit) {
			// Remove the oldest entry
			let current = this.history;
			this.history = current.next;
			this.size--;
		  }
		  let current = this.history;
		  while (current.next) {
			current = current.next;
		  }
		  current.next = { data, next: null };
		  this.size++;
		}
	}

	getHistoryBeforeLast = () => {
        // Retrieve the entry just before the last entry in the history
        if (!this.history || !this.history.next) {
          return null; // If there are 0 or 1 entries in history
        }
        let current = this.history;
        while (current.next && current.next.next) {
          current = current.next;
        }
        return current.data;
      }

	  goTo = (path, state = {}) => {
	    if (!path || typeof path !== "string") {
	      throw new Error("goTo(path) requires a URI string");
	    }

	    if (window.location.pathname === path) {
	      return;
	    }

	    window.history.pushState(state, "", path);
	    window.dispatchEvent(new PopStateEvent("popstate", { state }));
	  };
	  			  	  	  
	openSidePanel = (body, title, getContext) => {
		this.openSidePanelEvent.publish({body: body, title: title, getContext: getContext})
	}
	
	openModal = (body, title, callback, getContext) => {
		this.openModalEvent.publish({body: body, title: title, callback: callback, getContext: getContext})
	}
	
	closeModal = () => {
		this.closeModalEvent.publish();
	}

	closeSidePanel = () => {
		this.clodeSidePanelEvent.publish();
	}

	switchView = function (v) {
		// default behavior for now is one view at a time
		// this will eventually change though
		if (this.state.focusedView) {
			if (this.state.focusedView.uuid==v.uuid)
				return;
			else {
				this.unregister(this.state.focusedView);
				this.canISwitch.hangUp();
			}
		}
		if (!this.views.has(v.uuid)) {

			this.register(v);
		}
		if(v.getContext)
			setContextualOptions(v.getContext());
		this.setState({focusedView:v});
		this.requestingClose = false;
	}
	
	buildDesktop = () => {
		let Desktop;
		for (const [uuid, v] of this.views.entries()) {
			Desktop = <>{v.view()}
			<SidePanelComponent openEvent={this.openSidePanelEvent} closeEvent={this.clodeSidePanelEvent} />
			<Suspense fallback={<div>{t`Loading`}...</div>}>
			<DraggableModalBrowser openEvent={this.openModalEvent} closeEvent={this.closeModalEvent} />
			</Suspense>
			</>
		}
		return Desktop;
	}
	
}